import { render, staticRenderFns } from "./SGPTextTooltipComponent.vue?vue&type=template&id=50cbb9ab&scoped=true"
import script from "./SGPTextTooltipComponent.vue?vue&type=script&lang=js"
export * from "./SGPTextTooltipComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTextTooltipComponent.vue?vue&type=style&index=0&id=50cbb9ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cbb9ab",
  null
  
)

export default component.exports